// MicrosoftSignInButton — the way in, in Microsoft's design rather than ours.
//
// Alex, 2026-09-18: "we will have to change the login to Microsoft." The button
// had been a plain styled <a> since sign-in shipped — no Microsoft mark, our own
// fill, our own type. That was already off-spec before the theme change; the
// Snow/Stone repaint only made it obvious, because the button went from a navy
// block to a grey one and stopped reading as a primary action at all.
//
// ⚠ THIS BUTTON IS NOT OURS TO RETHEME. Microsoft's identity-branding guidelines
// fix the mark's four colours, the two permitted grounds (white / #2F2F2F), the
// 15px Segoe UI label and the square corners. So it deliberately does NOT use
// --fill-emphasis, --fs-small or CARD_RADIUS: if it followed our tokens it would
// silently drift off-spec the next time someone swaps the palette, which is
// exactly what happened to it this week. Its tokens are --th-ms-* and they are
// pinned in layer 1 of theme.css. The ONE thing that follows the theme is which
// of Microsoft's two treatments is used — light ground in light mode, dark
// ground in dark mode — which is a choice the guidelines offer.
//
// ⚠ IT IS AN <a>, NOT A BUTTON WITH A fetch — same reasoning as SignOutButton:
// signing in is a top-level navigation that leaves this origin entirely. A fetch
// would be an XHR to an OAuth authorize endpoint, which cannot work.
//
// The mark is inline SVG rather than an <img> so it inherits nothing and needs
// no asset round-trip; the four squares are theme tokens because the style guard
// (rightly) refuses raw hex in src/web.

// The four-square mark, at the 21x21 the guidelines specify for a 41px button.
// Order is fixed: orange top-left, green top-right, blue bottom-left, yellow
// bottom-right. It is decorative here — the button's own text is the label — so
// it carries aria-hidden and the <a> carries the accessible name.
function MicrosoftMark() {
  return (
    <svg
      width="21" height="21" viewBox="0 0 21 21" aria-hidden="true"
      style={{ flexShrink: 0, display: 'block' }}
    >
      <rect x="0"  y="0"  width="10" height="10" fill="var(--th-ms-red)" />
      <rect x="11" y="0"  width="10" height="10" fill="var(--th-ms-green)" />
      <rect x="0"  y="11" width="10" height="10" fill="var(--th-ms-blue)" />
      <rect x="11" y="11" width="10" height="10" fill="var(--th-ms-yellow)" />
    </svg>
  );
}

export default function MicrosoftSignInButton({ href }) {
  return (
    <a
      href={href}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 12,
        height: 41, padding: '0 12px', boxSizing: 'border-box',
        // Square corners and a 1px #8C8C8C border are both spec, as is the
        // absence of any shadow or hover fill.
        borderRadius: 0, border: '1px solid var(--th-ms-btn-border)',
        background: 'var(--th-ms-btn-bg)', color: 'var(--th-ms-btn-text)',
        fontFamily: 'var(--ff-ms-btn)', fontSize: 'var(--fs-ms-btn)',
        fontWeight: 400, lineHeight: 1, textDecoration: 'none', whiteSpace: 'nowrap',
      }}
    >
      <MicrosoftMark />
      {/* Exact wording is spec too — not "Log in", not "Continue with Microsoft". */}
      Sign in with Microsoft
    </a>
  );
}
